import { Customer } from './customer'
import { Checkout } from './checkout'
import { Promotion } from './promotion'
import { Product } from './product'
import { Service } from './service'
import { Staff } from './staff'
import { Group } from './group'
import { CustomerPoint } from './customer_point'


export class Checkin {
  constructor(checkin){
    this.id = checkin.id;
    this.customer_id = checkin.customer_id;
    this.create_at = checkin.create_at;
    this.status = checkin.status;
    this.update_at = checkin.update_at;
    this.counter = checkin.counter;
    this.number_checkin = checkin.number_checkin;
    this.attachment = checkin.attachment;

    this.customer = new Customer(checkin.customer);
    this.customer_point = new CustomerPoint(checkin.customer_point);
    this.check_out = new Checkout(checkin.check_out);
    this.promotions = checkin.promotions ? this.getPromotionList(checkin.promotions) : [];
    this.services = checkin.services ? this.getServiceList(checkin.services) : [];
    this.staffs = checkin.staffs ? this.getStaffList(checkin.staffs) : [];
    this.rewards = checkin.rewards;
    this.products = checkin.products ? this.getProductList(checkin.products) : [];
    this.groups = checkin.groups ? this.getGroupList(checkin.groups) : [];
    this.customer_checkin_services = checkin.customer_checkin_services;
  }
  getServiceList(services) {
    let ser_arr = [];
    for(let i = 0; i < services.length; i++) {
      ser_arr.push(new Service(services[i]));
    }
    return ser_arr;
  }

  getPromotionList(promotions) {
    let promo_arr = [];
    for(let i = 0; i < promotions.length; i++) {
      promo_arr.push(new Promotion(promotions[i]));
    }
    return promo_arr;
  }

  getStaffList(staffs) {
    let staff_arr = [];
    for(let i = 0; i < staffs.length; i++) {
      staff_arr.push(new Staff(staffs[i]));
    }
    return staff_arr;
  }

  getProductList(products) {
    let pro_arr = [];
    for(let i = 0; i < products.length; i++) {
      pro_arr.push(new Product(products[i]));
    }
    return pro_arr;
  }

  getGroupList(groups) {
    let group_arr = [];
    for(let i = 0; i < groups.length; i++) {
      group_arr.push(new Group(groups[i]));
    }
    return group_arr;
  }
}